import { Show, createSignal, onMount } from "solid-js";
import { PatcherSet } from "../patcher";
import { createID } from "../patcher/utils/html";

export default function ({ patcherSets }: { patcherSets: PatcherSet[] }) {
  const supportedDlls = [
    ...new Set(
      patcherSets.map(v => v.filename),
    )
  ];

  const id = createID();
  const [fullMatch, setFullMatch] = createSignal(false);

  let fileInput: HTMLInputElement;
  let card: HTMLDivElement;

  const unload = () => {
    patcherSets.forEach(v => v.unload());
  }

  const loadFile = (file: File) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      if (!e.target) return;
      if (!(e.target.result instanceof ArrayBuffer)) return;

      setFullMatch(false);

      for (const patcherSet of patcherSets) {
        if (supportedDlls.length > 1 &&
          patcherSet.filename != file.name
        ) {
          continue;
        }

        const [_, setVisible] = patcherSet.visible;

        patcherSet.loadBuffer(e.target.result);

        if (patcherSet.validatePatches()) {
          setFullMatch(true);
          setVisible(true);
          break;
        }
      }
    }

    reader.readAsArrayBuffer(file);
  };

  onMount(() => {
    fileInput.addEventListener('change', () => {
      if (!fileInput.files?.length) return;
      unload();
      
      for (const file of fileInput.files) {
        loadFile(file);
      }
    });

    let dragoverCounter = 0;

    ['dragover', 'dragenter', 'dragleave', 'dragend', 'drop'].forEach(n => {
      document.documentElement.addEventListener(n, (e) => {
        e.preventDefault();
      })
    });

    document.documentElement.addEventListener('dragenter', () => {
      if (!dragoverCounter) {
        card.classList.add('dragover');
      }

      dragoverCounter++;
    });

    document.documentElement.addEventListener('dragleave', () => {
      dragoverCounter--;

      if (!dragoverCounter) {
        card.classList.remove('dragover');
      }
    });

    document.documentElement.addEventListener('drop', (e) => {
      card.classList.remove('dragover');
      dragoverCounter = 0;

      if (!e?.dataTransfer?.files?.length) return;

      unload();

      for (const file of e.dataTransfer.files) {
        loadFile(file);
      }
    })
  });

  return (
    <div ref={card!} class="card">
      <div class="card-body m-2">
        <h4 class="mb-3">{supportedDlls.join(', ')}</h4>
        <div class="fp-container btn btn-success mb-3 pb-0">
          <input ref={fileInput!} type="file" id={id} />
          <label for={id}><strong>选择</strong> 或拖拽文件</label>
        </div>
        <h4>支持的版本: <b><small>(点击版本即可预览补丁列表)</small></b></h4>

        <ul>
          {
            patcherSets.map(v => {
              const [validated] = v.validated;
              const [validPatches] = v.validPatches;
              const [dllFile] = v.dllFile;
              const [_, setVisible] = v.visible;

              const id = createID();
              
              return (
                <li class="mt-2">
                  <div class="d-flex justify-content-between">
                    <label class="patchPreviewLabel" for={id}>{v.name}</label>
                    <Show when={(fullMatch() && validated()) || (!fullMatch() && dllFile())}>
                      <Show when={!validated()}>
                        <div class="matchPercent">
                          <span>{validPatches()} / {v.totalPatches} 个匹配的补丁 ({(validPatches() / v.totalPatches * 100).toFixed(1)} %)</span>
                          <button class="btn btn-danger" onclick={() => setVisible(true)}>强行加载?</button>
                        </div>
                      </Show>
                      <Show when={validated()}>
                        <span class="matchSuccess">所有补丁已成功加载 ({validPatches()} 个)</span>
                      </Show>
                    </Show>
                  </div>
                  <input type="checkbox" id={id} class="patchPreviewToggle" />
                  <ul class="patchPreview">
                    {
                      v.mods
                        .filter(v => !v.uiOnly)
                        .map(v => (
                          <li>{v.name}</li>
                        ))
                    }
                  </ul>
                </li>
              );
            })
          }
        </ul>
      </div>
    </div>
  );
}
